import { Controller } from "@hotwired/stimulus"

export default class OverviewLayoutController extends Controller {
  static targets = ["fold", "item"]
  static values = { size: Number }

  connect() {
    this.foldsVisible = true
  }

  showFolds() {
    if (!this.foldsVisible) {
      this.#calculateFoldPositions()
      this.foldsVisible = true
    }
  }

  hideFolds() {
    this.foldTargets.forEach((fold) => fold.remove())
    this.foldsVisible = false
  }

  #calculateFoldPositions() {
    this.foldTargets.forEach((fold) => fold.remove())
    this.itemTargets.reduce((currentPageRemainingCells, item) => {
      const itemSize = item.dataset.tileWidth * item.dataset.tileHeight
      if (currentPageRemainingCells + itemSize > this.sizeValue) {
        this.#insertFold(item)
        return itemSize
      } else {
        return currentPageRemainingCells + itemSize
      }
    }, 0)
  }

  #insertFold(item) {
    const fold = document.createElement("div")
    fold.setAttribute("data-overview-layout-target", "fold")
    fold.classList.add(
      "w-full",
      "h-0",
      "col-span-full",
      "border-b-4",
      "border-dashed",
      "border-gray-300"
    )
    item.insertAdjacentElement("beforebegin", fold)
  }
}
